var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"pa-0",attrs:{"id":"main-container","fluid":""}},[_c('iframe',{attrs:{"width":"100%","height":_vm.height,"src":"https://lamonnaiepirate.net"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }